module.exports = __webpack_public_path__ + "img/McDonalds.edf8fe89.svg";